import {Subject} from "rxjs/Subject";

export default function firebaseUpdate(dbRef, data) {

    const subject = new Subject();

    dbRef.update(data)
        .then(
            val => {
                subject.next(val);
                subject.complete();
            },
            err => {
                subject.error(err);
                subject.complete();
            }
        );

    return subject.asObservable();

}


// WEBPACK FOOTER //
// ./src/app/services/firebase/firebaseUpdateToObs.ts